module.exports = __webpack_public_path__ + "img/servicenow.71735229.png";